import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Card, Tabs, Tab, Stack, Box, styled, Button, Grid } from "@mui/material";
import {
	CARD_CLASSSOCIETY_ICON, CARD_DECK_ICON, CARD_ENGINE_ICON, CARD_PORT_AUTHORITY_ICON, CARD_SHIP_ICON,
	PERSONAL_CONTACT_ICON, UNCATEGORISED_ICON,
} from "../../../utils/constants";
import { colorMappingDataSet } from "../../../utils/ColorMapping";
import { selectedContactAction } from "../../../state/actions/contacts";
import { useNavigate } from "react-router-dom";
import { createConversation, setSelectedContactData, setSelectedOnetoOneChat } from "../../../state/actions/chats";
import { getAuthData } from "../../../services/storage/LocalStorage";

import Contacts from "../Contacts";
import CustomSwitchWithCount from "../components/IOSSwitch";
import CachedImage from "../../../components/common/CachedImage";
import AddNewContactFunctional from "../AddNewContact/AddNewContactFunctional";
import ModalNewUI from "../../../components/ui/Modals/ModalMessages/ModalNewUI";
import { setHideDefaultHomepageBot } from "../../../state/actions/bot";
import { removeBot } from "../../../state/actions/domain";
import { setHeaderTitle } from "../../../state/actions/layout";


const CategoryCard = styled(Card)({
	boxShadow: "2px 8px 20px #E0E0FF",
	borderRadius: "8px",
	width: "100%",
	display: "flex",
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
});

const StyledAccordion = styled(Accordion)({
	overflow: "hidden",
	'::before': {
		content: "none"
	}
});

const StyledTabItem = styled(Tab)(({ theme, selected }) => ({
	color: selected ? "#404585" : "#8387BD",
	fontFamily: 'Figtree-Regular',
	fontSize: '14px',
	fontWeight: selected ? "600 !important" : "400 !important",
	marginTop: "0.5rem",
}));

const CATEGORY_TABS = ["All", "Shore", "Ship", "Directory"];

const ZeroState = () => {
	return (
		<>
			<CachedImage image={"/img/contacts_zero_state.svg"} />
			<Typography variant="h6" sx={{ mt: "2rem", fontFamily: "FigTree-Regular", fontWeight: "600", color: "#15194B" }}>
				Results not found
			</Typography>
			<Typography variant="subtitle1" sx={{ color: "#8387BD", fontFamily: "FigTree-Regular" }}>
				There are no matching contacts
			</Typography>
		</>
	);
};

const RenderIcon = (mainCategory) => {
	const iconPaths = {
		Shore: CARD_SHIP_ICON,
		Deck: CARD_DECK_ICON,
		Ship: CARD_SHIP_ICON,
		Engine: CARD_ENGINE_ICON,
		"Port Authority": CARD_PORT_AUTHORITY_ICON,
		"Classification Society": CARD_CLASSSOCIETY_ICON,
		Personal: PERSONAL_CONTACT_ICON,
		Uncategorised: UNCATEGORISED_ICON,
	};

	return (
		<img
			src={iconPaths[mainCategory] || CARD_ENGINE_ICON}
			alt={`${mainCategory} icon`}
			style={{ width: "20px", height: "20px" }}
		/>
	);
};

const getColor = (contactData) => {
	let rankLevel1 = contactData?.rankLevel1?.toLowerCase();
	let rankLevel2 = contactData?.rankLevel2?.toLowerCase();

	if (!rankLevel1 || rankLevel1 === 'directory') return colorMappingDataSet['generic'];
	let color = colorMappingDataSet['generic'];

	if (rankLevel1 && rankLevel2) {
		color = colorMappingDataSet[rankLevel1][rankLevel2];
	}
	return color;
}

const ContactsListFunctional = (props) => {
	const {
		fetchContacts,
		showMenu,
		toggleMenu,
		allProfileImages,
		selectedId,
		userId,
		favourites,
		removeConversationFromFavourites,
		addConversationToFavourites,
		searchText,
		selectedDomain,
		filteredContacts,
		balance,
		openRecharge,
		user,
		addContactMenu,
		setAddContactMenu
	} = props;

	const [expanded, setExpanded] = useState({});
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const userDetail = getAuthData();
	const userData = userDetail.user || {};

	const startConversation = (contact) => {
		const userId = user?.user?.userId ?? userData.userId
		dispatch(removeBot())
		dispatch(setHideDefaultHomepageBot());
		dispatch(setSelectedOnetoOneChat(true));
		dispatch(setSelectedContactData(contact));
		dispatch(createConversation(userId, null, selectedDomain, contact));
		dispatch(setHeaderTitle("Connect"));
		navigate("/app/messages");
	};

	const [selectedTab, setSelectedTab] = useState(null);

	const {
		accepted,
		localContacts,
		domainContacts,
		directoryContacts,
		shipContacts,
		shoreContacts,
		isDataLoaded,
		allContacts,
		selectedContact
	} = useSelector((state) => state.contacts);

	const [selectedTabData, setSelectedTabData] = useState([]);
	const [showTabs, setShowTabs] = useState(true);

	const styles = {
		filterContainer: {
			width: "100%",
			backgroundColor: "#fff",
			borderRadius: "1rem",
			boxShadow: "2px 8px 20px #E0E0FF",
			overflow: "hidden",
			p: 0,
		},
		contactName: {
			color: "#404585",
			marginLeft: "10px",
			fontSize: "16px",
			fontWeight: 600,
			fontFamily: "Figtree-Regular",
		},
		accordion: {
			width: "100%",
			boxShadow: "2px 8px 20px #E0E0FF",
			margin: "0.4rem 0",
			borderRadius: "1rem !important",
		},
		accordionSummary: {
			minHeight: 50,
			"& .MuiAccordionSummary-content": {
				display: "flex",
				alignItems: "center",
				margin: '0.25rem 0 !important',
			},
			height: "5rem",
			borderBottom: '1px solid #E5E5FF',
		},
		gridItem: {
			display: "flex",
			alignItems: "center",
			justifyContent: 'flex-start',
		},
	}

	useEffect(() => {
		dispatch(fetchContacts({ selectedDomain: selectedDomain }))
		setSelectedTab(3);
		setShowTabs(true);
		if (searchText === "") dispatch(selectedContactAction({}));
	}, [searchText === ""]);


	useEffect(() => {
		dispatch(fetchContacts({ selectedDomain: selectedDomain }, true))
	}, [localContacts?.length, accepted?.length, domainContacts?.length]);

	const handleTabChange = (event, newValue) => {
		setSelectedTab(newValue);
	};

	const toggleAccordion = (title) => {
		setExpanded((prev) => {
			if (prev[title]) {
				return { [title]: !prev[title] };
			} else {
				return { [title]: true }
			}
		});
	};

	const getSelectedTabData = () => {
		switch (CATEGORY_TABS[selectedTab]?.toLowerCase()) {
			case "all":
				return allContacts;
			case "shore":
				return shoreContacts;
			case "ship":
				return shipContacts;
			case "directory":
				return directoryContacts;
			default:
				return [];
		}
	};

	useEffect(() => {
		(async () => {
			let selectedTabContacts = await getSelectedTabData();

			if (!isDataLoaded) {
				let contactList = [];
				selectedTabContacts?.map((x) => contactList?.push(...x.contacts));
				if (!contactList.find(x => x.userId === selectedContact?.userId)) {
					setExpanded(false);
					dispatch(selectedContactAction({}));
				}
				setSelectedTabData(selectedTabContacts);
			}
		})();
	}, [selectedTab, allContacts]);

	useEffect(() => {
		if (filteredContacts?.length >= 0 && searchText !== "") {
			setShowTabs(false);
		}
		if (selectedContact?.userId && !filteredContacts?.find(x => x?.userId === selectedContact.userId)) {
			dispatch(selectedContactAction({}));
		}
	}, [filteredContacts?.length, (filteredContacts?.length === 0 && searchText !== "")]);

	const renderCategory = (cardData) => {
		let accordionId = cardData.title + '-' + cardData?.type;
		return (
			<StyledAccordion
				square={false}
				disableGutters
				expanded={!!expanded[accordionId]}
				onChange={() => toggleAccordion(accordionId)}
				key={accordionId}
				sx={{ ...styles.accordion, borderLeft: `5px solid ${getColor({ rankLevel1: cardData?.type, rankLevel2: cardData?.title })}` }}
			>
				<AccordionSummary sx={styles.accordionSummary}>
					<Grid container flexDirection='column' alignItems='start' justifyContent='start' sx={{ position: 'relative', width: '100%' }}>
						{cardData?.type && selectedTab === 0 && <Stack flexDirection='row' alignItems='center' sx={{ position: 'absolute', top: '-24px' }}>
							<Box sx={{ backgroundColor: getColor({ rankLevel1: cardData?.type, rankLevel2: cardData?.title }), mr: 1, ml: 0.5, width: '0.35rem', height: '0.35rem', borderRadius: '100%' }} />
							<Typography sx={{ fontFamily: 'Figtree-Regular', fontSize: '13px' }}>{cardData?.type.charAt(0).toUpperCase() + cardData?.type.slice(1)}</Typography>
						</Stack>}
						<Stack flexDirection='row' alignItems='center' justifyContent='space-between' sx={{ width: '100%' }}>
							<Grid sx={styles.gridItem}>
								{RenderIcon(cardData.title)}

								<Typography variant="h6" sx={styles.contactName} className="!text-size-14" >
									{cardData.title}
								</Typography>
							</Grid>

							<Grid>
								<CustomSwitchWithCount
									count={cardData.count > 99 ? '99+' : cardData.count}
									expanded={!!expanded[accordionId]}
									toggleExpand={() => toggleAccordion(accordionId)}
								/>
							</Grid>
						</Stack>
					</Grid>
				</AccordionSummary>
				<AccordionDetails sx={{ p: 0 }}>
					<Contacts
						contacts={cardData.contacts}
						balance={balance}
						openRecharge={openRecharge}
						userId={userId}
						showMenu={showMenu}
						selectedId={selectedId}
						toggleMenu={toggleMenu}
						onContactClicked={selectedContactAction}
						startConversation={startConversation}
						allProfileImages={allProfileImages}
						fetchContacts={fetchContacts}
						favourites={favourites}
						removeConversationFromFavourites={removeConversationFromFavourites}
						addConversationToFavourites={addConversationToFavourites}
					/>
				</AccordionDetails>
			</StyledAccordion>
		);
	};


	const showAddContact = () => setAddContactMenu(true);
	const closeAddContact = () => setAddContactMenu(false);

	return (
		<>
			{showTabs && (<Stack flexDirection='column' alignItems='center' justifyContent='center' gap='1rem' sx={{ mb: 1 }}>
				<CategoryCard>
					<Tabs
						value={selectedTab||0}
						onChange={handleTabChange}
						TabIndicatorProps={{
							style: {
								backgroundColor: "#6267AD",
								height: "3px",
								borderRadius: "4px",
							},
						}}
						textColor="#404585"
						variant="fullWidth"
						sx={{
							width: "90%",
							margin: "0 auto",
							".MuiTab-root": {
								textTransform: "capitalize",
								fontWeight: "600",
								fontFamily: "Figtree-Regular",
								fontSize: "14px",
							},
						}}
					>
						<StyledTabItem label="All" tabIndex={0} />
						<StyledTabItem label="Shore" tabIndex={1} />
						<StyledTabItem label="Ship" tabIndex={2} />
						<StyledTabItem label="Directory" tabIndex={3} />
					</Tabs>
				</CategoryCard>
			</Stack>)}
			<Scrollbars
				autoHide
				style={{ height: showTabs ? "70vh" : "82vh" }}
			>
				<Stack flexDirection="column" alignItems="center" gap="1rem" sx={{ marginBottom: '3rem' }}>
					<Stack flexDirection="column" sx={{ width: "100%" }}>
						{showTabs && selectedTabData?.length > 0 &&
							selectedTabData.map((tabData) => {
								return tabData.count > 0 && renderCategory(tabData);
							})}
						{selectedTabData?.length === 0 && searchText === "" && (
							<Stack
								flexDirection="column"
								alignItems="center"
								margin={"10rem 2rem 0 2rem"}
								gap="1rem"
							>
								<Typography
									sx={{
										color: "#15194B",
										fontSize: "14px",
										textAlign: "center",
										fontWeight: 600,
										fontFamily: "Figtree-Regular",
										lineHeight: "16px",
									}}
								>
									Oops! Contact Not Found
								</Typography>
								<Typography
									margin={"0 2rem"}
									sx={{
										color: "#8387BD",
										fontSize: "14px",
										textAlign: "center",
										fontWeight: 400,
										fontFamily: "Figtree-Regular",
										lineHeight: "18px",
									}}
								>
									Change search keyword or please click on<br></br>“Add new
									Contact”
								</Typography>
								<Button
									variant="contained"
									onClick={showAddContact}
									style={{
										color: "white",
										backgroundColor: "#376AFA",
										border: "1.2px solid #376AFA",
										borderRadius: 6,
										textTransform: "none",
										fontFamily: "Figtree-Regular",
										fontWeight: 600,
										fontSize: "14px",
										// width: 250,
										height: 40,
									}}
								>
									Connect with <span className="lowercase ml-1">{selectedDomain}</span>users
								</Button>
							</Stack>
						)}
						{!showTabs && filteredContacts?.length > 0 && searchText !== "" && (
							<Stack flexDirection="column" alignItems="center" gap="1rem">
								<Box sx={styles.filterContainer}>
									<Contacts
										contacts={filteredContacts}
										balance={balance}
										openRecharge={openRecharge}
										userId={userId}
										showMenu={showMenu}
										selectedId={selectedId}
										toggleMenu={toggleMenu}
										onContactClicked={selectedContactAction}
										startConversation={startConversation}
										allProfileImages={allProfileImages}
										fetchContacts={fetchContacts}
										favourites={favourites}
										removeConversationFromFavourites={removeConversationFromFavourites}
										addConversationToFavourites={addConversationToFavourites}
									/>
								</Box>
							</Stack>
						)}
						{filteredContacts?.length === 0 && searchText !== "" && (
							<Stack
								flexDirection="column"
								alignItems="center"
								margin={"2rem"}
								gap="1rem"
							>
								<Box className="px-2 text-center">
									<ZeroState />
								</Box>
							</Stack>
						)}

					</Stack>
				</Stack>
			</Scrollbars>
			{addContactMenu && (
				<ModalNewUI
					onClose={closeAddContact}
					headerContent={"Add new contact"}
					open={addContactMenu}
					customDialogStyles={{ width: '1050px', maxWidth: '1200px', height: '600px', maxHeight: '700px', overflowY: 'hidden' }}
				>
					<AddNewContactFunctional
						{...props}
						cancel={closeAddContact}
						selectedTabFromParent="connectUsers"
						fetchContacts={(data) => {
							props.fetchContacts(data, true);
						}}
					/>
				</ModalNewUI>
			)}
		</>
	);
};

export default ContactsListFunctional;
